export let MiscellaneousPaymentRoutes = {
    "/miscellaneous-payment?date&type": {
        "name": "schedule.miscellaneous-payment",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./miscellaneous-payment.module.js");
                }
            }
        ]
    },
};